import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environment } from "../../shared/config/environment";
import axios from "axios";

const initialState = {
  user_id: null,
  tenant_id: null,
  subscription_id: null,
  grand_total: 0,
  tax_total: 0,
  taxable_value: 0,
  order_items: [
    {
      plan_id: null,
      quantity: 1,
      price: 0,
      tax_rate: 18,
      subtotal: 0,
    },
    {
      addon_id: null,
      quantity: 0,
      price: 0,
      tax_rate: 18,
      subtotal: 0,
    },
  ],
  order_billing_addresses: [
    {
      name: null,
      phone_number: null,
      address1: null,
      address2: null,
      city: null,
      pincode: null,
      state: null,
      gstin: null
    },
  ],
  status: {
    success: false,
    error: false,
    errorMessage: "",
    successMessage: "",
    orderResponse: {}
  },
  addressSuccess: false,
};

export const createOrder = createAsyncThunk(
  "orderEntity/create",
  async (args, { rejectWithValue }) => {
    try {
      var config = {
        method: "POST",
        url: environment.URL + "tenants/orders",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${args.access_token}`,
          "X-Tenant": args?.tenantId
        },
        data: args.data,
      };
      const orderData = await axios(config);
      return orderData?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message);
    }
  }
);

const orderEntitySlice = createSlice({
  name: "orderEntity",
  initialState,
  reducers: {
    setPlan(state, action) {
      console.log("action payload for plan id", action.payload);
      state.order_items[0]["plan_id"] = action.payload.plan_id;
      state.order_items[0]["price"] = action.payload.price;
      console.log(
        "action payload for plan id",
        state.order_items[0]["plan_id"]
      );
    },
    setBillingAddress(state, action) {
      let { field, value } = action.payload;
      state.order_billing_addresses[0][field] = value;
    },
    setAddon(state, action) {
      state.order_items[1]["addon_id"] = action.payload.addon_id;
      state.order_items[1]["price"] = action.payload.price;
    },
    updateAddonQty(state, action) {
      state.order_items[1]["quantity"] = action.payload;
    },
    // Toggle a feature addon (non-user addon) as separate order_items row
    // payload: { addon: { id, price, tax_rate } }
    toggleFeatureAddon(state, action) {
      const { addon } = action.payload || {};
      if (!addon || !addon.id) return;
      const idx = state.order_items.findIndex(
        (it, i) => i > 1 && it.addon_id === addon.id
      );
      if (idx >= 0) {
        // remove existing feature addon line
        state.order_items.splice(idx, 1);
      } else {
        // add feature addon line with quantity 1
        state.order_items.push({
          addon_id: addon.id,
          quantity: 1,
          price: addon.price || 0,
          tax_rate: addon.tax_rate ?? 18,
          subtotal: 0,
        });
      }
    },
    // Explicitly set a feature addon present or not
    setFeatureAddon(state, action) {
      const { addon, enabled } = action.payload || {};
      if (!addon || !addon.id) return;
      const idx = state.order_items.findIndex(
        (it, i) => i > 1 && it.addon_id === addon.id
      );
      const exists = idx >= 0;
      if (enabled && !exists) {
        state.order_items.push({
          addon_id: addon.id,
          quantity: 1,
          price: addon.price || 0,
          tax_rate: addon.tax_rate ?? 18,
          subtotal: 0,
        });
      } else if (!enabled && exists) {
        state.order_items.splice(idx, 1);
      }
    },
    recalcTotals(state, action) {
      let orderItems = state.order_items;
      let grand_total = 0;
      let tax_total = 0;
      let taxable_value = 0;
      orderItems.map((value, index) => {
        let tempQty = value.quantity;
        let tempPrice = value.price;
        let tempTaxable = tempQty * tempPrice;
        let tax = tempTaxable * (value.tax_rate / 100);
        let subtotal = tempTaxable + tax;
        orderItems[index]["subtotal"] = subtotal;
        grand_total += subtotal;
        tax_total += tax;
        taxable_value += tempTaxable;
      });
      state.grand_total = grand_total;
      state.tax_total = tax_total;
      state.taxable_value = taxable_value;
    },
    updateAddressStaus(state, action) {
      state.addressSuccess = action.payload;
    },
    resetOrderEntity: () => initialState,
    resetBillingAddress(state, action) {
      state.order_billing_addresses = [
        {
          name: "",
          phone_number: "",
          address1: "",
          address2: "",
          city: "",
          pincode: "",
          state: "",
          gstin: ""
        },
      ]
    }
  },
  extraReducers(builder) {
    builder
      .addCase(createOrder.fulfilled, (state, action) => {
        state.status.success = true;
        state.status.successMessage = "Order created";
        state.status.orderResponse = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.status.error = false;
        state.status.errorMessage = "Unable to place order";
      });
  },
});

export const {
  setPlan,
  resetOrderEntity,
  updateAddonQty,
  setAddon,
  toggleFeatureAddon,
  setFeatureAddon,
  setBillingAddress,
  recalcTotals,
  updateAddressStaus,
  resetBillingAddress
} = orderEntitySlice.actions;

export default orderEntitySlice.reducer;
